import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import { IValidateResponse } from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import * as yup from 'yup';
import { Try } from '../Try';
import { useFormSubmit } from '../hooks/useFormSubmit';
import { useSnackbarNotify } from '../hooks/useSnackbarNotify';
import { CancelSubmitFormDialogActions } from './CancelSubmitFormDialogActions';
import { FormIntegerField } from './FormIntegerField';
import { handleValidateResponse } from './utils/handleValidateResponse';

interface IModel {
	value: number;
}

const createSchema = (strings: IStrings, label: string) => {
	return yup.number().required(strings.formRequired(label));
};

interface IProps extends DialogProps {
	formTitle: string;
	label: string;
	notifyMessage?: string;
	initialValue: number | undefined;
	confirm: VoidFunction;
	cancel: VoidFunction;
	submitFunction: (value: number) => Promise<Try<IValidateResponse>>;
}

export const IntegerNumberModelForm = ({ notifyMessage, formTitle, initialValue, submitFunction, label, confirm, cancel, ...rest }: IProps) => {
	const strings = useLocalization();
	const notify = useSnackbarNotify();
	const [update, isSubmitting] = useFormSubmit(submitFunction);

	const handleSubmit = async (value: IModel, helpers: FormikHelpers<IModel>) => {
		const r = await update(value.value);
		if (handleValidateResponse(r, helpers, 'value')) {
			if (notifyMessage) {
				notify(notifyMessage);
			}
			confirm();
		}
	};

	return (
		<Formik
			validateOnMount
			validationSchema={createSchema(strings, label)}
			initialValues={{ value: initialValue as any }}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					maxWidth='xs'
					{...rest}>
					<DialogTitle>{formTitle}</DialogTitle>
					<DialogContent
						dividers
						className='df-col'>
						<FormIntegerField<IModel>
							name='value'
							label={label}
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						submitText={strings.update}
						isSubmitting={isSubmitting}
						cancel={cancel}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
